import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoutes, FundService } from '@gs-2.0/core';

import FundTypes from '../constants/fund-types';
import { AccessLevels } from '../constants/user-role';

export const fullAccessGuard: CanActivateFn = async () => {
  const fundService = inject(FundService);
  const selectedFund = fundService.selectedFund();
  const router = inject(Router);

  if (!selectedFund) {
    await fundService.loadFunds();
  }

  if (fundService.isExpiredFund()) {
    router.navigate([AppRoutes.FUND_DASHBOARD]);
    return false;
  }

  if (
    fundService.isFullAccess() ||
    (selectedFund.fundType === FundTypes.PROJECT &&
      selectedFund.contactRoleAccessLevel === AccessLevels.PROJECT_TRANSFER)
  ) {
    return true;
  }

  router.navigate([AppRoutes.FUND_DASHBOARD]);
  return false;
};
